import $ from 'jquery';

const initDropdown = () => {

    const buttonsCollection = document.getElementsByClassName('js-dropdown-initializer');

    if (!buttonsCollection) {
        return;
    }

    const activeClass = 'active';
    const ESC_BTN = 27;
    const $document = $(document);

    function createDropdown(id) {
        // const initialElement = document.getElementById(id);
        // const clone = initialElement.cloneNode(true);
        // clone.removeAttribute('id');
        // return clone;
        const initialElement = $document.find(`#${id}`);
        const clone = initialElement.clone(true);
        clone.removeAttr('id');
        return clone.get(0);
    }

    function showDropdown(dropdownWrap, buttonElem, dropdownToInsert) {
        // dropdownWrap.appendChild(dropdownToInsert);
        dropdownWrap.append(dropdownToInsert);
        buttonElem.classList.add(activeClass);
        buttonElem.isOpened = true;
    }

    function hideDropdown(dropdownWrap, buttonElem) {
        dropdownWrap.innerHTML = '';
        buttonElem.classList.remove(activeClass);
        buttonElem.isOpened = false;
    }

    function hideAllDropdowns(currentTarget) {
        Array.from(buttonsCollection).forEach((elem) => {
            if (elem === currentTarget) {
                return;
            }
            const dropdownWrap = elem.nextElementSibling;
            hideDropdown(dropdownWrap, elem);
        });
    }

    function createBodyClickHandler(dropdownElem, buttonElem) {
        return function bodyClickHandler(event) {
            event.stopPropagation();

            hideDropdown(dropdownElem, buttonElem);
            $document.off('click touchstart', bodyClickHandler);
        };
    }

    function createEscapeHandler(dropdownElem, buttonElem) {
        return function escapeKeyHandler(event) {
            if (event.keyCode !== ESC_BTN) {
                return;
            }
            hideDropdown(dropdownElem, buttonElem);
            $document.on('keyup', escapeKeyHandler);
        };
    }

    Array.from(buttonsCollection).forEach((elem) => {

        const id = elem.getAttribute('data-id');
        const dropdownWrap = elem.nextElementSibling;
        elem.isOpened = false;

        $(elem).on('click touchstart', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const targetBtn = event.currentTarget;
            const targetDropdown = createDropdown(id);

            hideAllDropdowns(targetBtn);

            if (!targetBtn.isOpened) {
                showDropdown(dropdownWrap, targetBtn, targetDropdown);
                $document.on('click touchstart', createBodyClickHandler(dropdownWrap, targetBtn));
                $document.on('keyup', createEscapeHandler(dropdownWrap, targetBtn));
            } else {
                hideDropdown(dropdownWrap, targetBtn);
            }
        });

        $(dropdownWrap).on('click touchstart', (event) => {
            event.stopPropagation();
            let $link = $(event.target).closest('.js-dropdown-link');
            let linkData = $link.attr('data-event');

            if (linkData === 'prevent-default') {
                event.preventDefault();

                const data = {
                    delegateEvent: event,
                    link: $link.length ? $link[0] : null
                };

                $(event.currentTarget).trigger('dropdown:click', data);
            }

            // event.stopPropagation();
        });
    });

};

export default initDropdown;
